import './App.css';
import TerrazzoTileCustomizer from './TerrazzoTileCustomizer';

function App() {
  return (
    <div className="App">
      <TerrazzoTileCustomizer />
    </div>
  );
}

export default App;